import { FC, useRef, useEffect } from "react";
import WarningCircle from "@/components/icons/WarningCircle";
import { Button } from "../../../ui/button";
import Footer from "./Footer";
import MainContent from "./MainContent";
import { useInView } from "react-intersection-observer";
import useElementEvents from "@/hooks/eventing/useElementEvents";
import {
  DEFAULT_USE_IN_VIEW_OPTIONS,
  ElementType,
} from "@/constants/tagular/main";
import { getCorrelationID } from "@/utils/tagular/helpers";

type ErrorProps = {
  errorCallback: () => void;
  location?: string;
};

const ErrorState: FC<ErrorProps> = ({
  errorCallback,
  location = "embedded-search",
}) => {
  const hasViewedRef = useRef(false);

  const webElement = {
    elementType: ElementType.Entry,
    htmlId: "search-error-button",
    location: location,
    name: `${location}-button`,
    text: "Try again",
  };
  const { elementClicked, elementViewed } = useElementEvents({
    correlationId: getCorrelationID(),
    webElement,
  });

  const { ref: inViewRef, inView } = useInView(DEFAULT_USE_IN_VIEW_OPTIONS);

  useEffect(() => {
    if (inView && !hasViewedRef.current) {
      hasViewedRef.current = true;
      elementViewed();
    }
  }, [inView, elementViewed]);

  return (
    <MainContent>
      <div className="w-full flex flex-col items-center pt-4 space-y-4 mb-6">
        <div className="flex items-center gap-2">
          <span className="text-danger-500">
            <WarningCircle
              svgProps={{ viewBox: "0 0 16 16", width: "20", height: "20" }}
            />
          </span>
          <span className="font-bold elm-p4 text-center">
            Something went wrong
          </span>
        </div>
        <span className="elm-p2 text-center text-putty-700 text-balance">
          We&apos;re having trouble loading your search results. Please try
          again.
        </span>
      </div>
      <Footer>
        {/* Maybe the styling of this div goes in the footer if it's consistent with all states */}
        <div className="w-full flex justify-center py-4">
          <Button
            ref={inViewRef}
            onClick={() => {
              errorCallback();
              elementClicked();
            }}
          >
            Try again
          </Button>
        </div>
      </Footer>
    </MainContent>
  );
};

export default ErrorState;
